module.exports = __webpack_public_path__ + "img/1421691.png";